// extracted by mini-css-extract-plugin
module.exports = {"fullScreenIframe":"fullscreen-iframe_fullScreenIframe__mjniK","closeButton":"fullscreen-iframe_closeButton__QCVco"};